<!--
  设备统计组件
-->

<template>
  <div class="dev_stat">
    <ContentSection
      :title="'设备统计'"
      :mainStyle="{ borderLeftStyle: 'solid' }"
      :position="'right'"
    >
      <div class="dev_main">
        <!-- <img src="@/assets/img/dev_chart.png"/> -->
        <div class="my_chart"></div>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import * as echarts from "echarts";
import ContentSection from "@/components/ContentSection";
export default {
  name: "devStat",
  components: {
    ContentSection,
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    this.setChart();
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.myChart.resize();
    });
  },
  methods: {
    // 配置 chart图所需数据
    setOption(){
      
      const data2 = [65, 50, 32, 60, 38];
      const sideData2 = data2.map((item) => item + 90);
      var colorArr = ["#0C628C", "#3887D5", "#2570BB"];
      var color = {
        type: "linear",
        x: 0,
        x2: 1,
        y: 0,
        y2: 0,
        colorStops: [
          {
            offset: 0,
            color: colorArr[0],
          },
          {
            offset: 0.5,
            color: colorArr[0],
          },
          {
            offset: 0.5,
            color: colorArr[1],
          },
          {
            offset: 1,
            color: colorArr[1],
          },
        ],
      };
      let barWidth = parseInt(this.$chartResize.textResize(30));
      let fontSize = this.$chartResize.textResize(24)
      // 折线图参数
      return {
        //  tooltip: {
        // 	 trigger: 'axis',
        // 	 formatter: function (params) {
        // 		 var str = params[0].name + ":";
        // 		 params.filter(function (item) {
        // 			 if (item.componentSubType == "bar") {
        // 				 str += "<br/>" + item.seriesName + "：" + item.value;
        // 			 }
        // 		 });
        // 		 return str;
        // 	 },
        //  },
        grid: {
          x: "7%",
          x2: "0%",
          y: "5%",
          y2: "20%",
        },
        legend: {
          show: false,
          //  data:['本期','同期'],
          textStyle: {
            color: "#fff",
            fontSize: "20",
          },
        },
        xAxis: {
          data: ["提升泵", "风机", "除鳞加药泵", "消毒加药泵", "污泥回流泵"],
          //坐标轴
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.5)",
              type: "dotted",
            },
            textStyle: {
              color: "#fff",
              fontSize: "10",
            },
          },
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize:fontSize
            },
            formatter:(value)=>{
              let str = ''
              for(let i in value){
                str += value[i]
                if(i== 1 && value.length > 3){
                  str += '\n'
                }
              }
              return str
            }
          },
          axisTick: {
            textStyle: {
              color: "#fff",
              // fontSize: "16",
            },
            show: false,
          },
          splitLine: { show: false },
        },
        yAxis: {
          show: false,
          max:80,
          //  type : 'value',
          //  //坐标轴
          //  axisLine :{
          // 	 show:true,
          // 	 lineStyle: {
          // 		 width: 1,
          // 		 color: '#214776'
          // 	 },
          // 	 textStyle:{
          // 		 color:'#fff',
          // 		 fontSize:'10'
          // 	 }
          //  },
          //  axisTick  :{
          // 	 show:false
          //  },
          //  //坐标值标注
          //  axisLabel: {
          // 	 show: true,
          // 	 textStyle: {
          // 		 color: '#C5DFFB',
          // 	 }
          //  },
          //  //分格线
          //  splitLine: {
          // 	 lineStyle: {
          // 		 color: '#13365f'
          // 	 }
          //  }
        },
        series: [
          {
            z: 1,
            name: "1",
            type: "bar",
            barWidth: barWidth,
            barGap: "50%",
            data: data2,
            label: {
              show: true,
              position: "outside",
              color:'#fff',
              fontSize:this.$chartResize.textResize(24)
            },
            itemStyle: {
              color: 
                {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0.3,
                    color: "rgba(0,143,255,0.4)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0,143,255,1)",
                  },
                ],
              },
            },
          },
          //  三维底部，片段
          {
            z: 2,
            name: "1",
            type: "pictorialBar",
            data: sideData2,
            symbol: "diamond",
            symbolOffset: ["0%", "50%"],
            symbolSize: [barWidth, 10],
            itemStyle: {
              color: "rgba(0,143,255,1)",
            },
            tooltip: {
              show: false,
            },
          },
          //  三维顶部片段
          {
            z: 3,
            name: "1",
            type: "pictorialBar",
            symbolPosition: "end",
            data: data2,
            symbol: "diamond",
            symbolOffset: ["0%", "-50%"],
            symbolSize: [barWidth - 4, (10 * (barWidth - 4)) / barWidth],
            itemStyle: {
              borderWidth: 2,
              color: "rgba(0,143,255,0.4)",
            },
            tooltip: {
              show: false,
            },
          },
        ],
      };
    },
    // 配置chart图
    setChart() {
      this.myChart = echarts.init(
        document.querySelector(".dev_main .my_chart")
      );
      this.myChart.setOption(this.setOption());
      // echart自适应
      window.addEventListener("resize", () => {
        this.myChart.setOption(this.setOption());
        this.$chartResize.chartResize(this.myChart)
      });
    },
  },
};
</script>

<style lang='less' scoped>
.dev_stat {
  .dev_main {
    width: 100%;
    height: 100%;
    display: flex;
    .my_chart {
      width: 785px;
      height: 531vh * @vh;
      margin: auto;
    }
  }
}
</style>